var map = {
	"./air-nga-en/translations/index.js": 74168,
	"./ais-tai-en/translations/index.js": 86187,
	"./ais-tai-tha/translations/index.js": 71405,
	"./demo-arabic/translations/index.js": 17853,
	"./demo-et-en/translations/index.js": 70412,
	"./demo-romanian/translations/index.js": 79744,
	"./demo-um-en/translations/index.js": 8819,
	"./dtac-tai-en/translations/index.js": 29764,
	"./dtac-tai-tha/translations/index.js": 83328,
	"./ethiotel-et-amh/translations/index.js": 4144,
	"./ethiotel-et-en/translations/index.js": 82085,
	"./mtn-cg-fr/translations/index.js": 21728,
	"./mtn-ci-fr/translations/index.js": 58826,
	"./mtn-cmr-fr/translations/index.js": 66388,
	"./mtn-gha-en/translations/index.js": 78385,
	"./mtn-nga-en/translations/index.js": 90717,
	"./mtn-zam-en/translations/index.js": 77483,
	"./saf-ke-en/translations/index.js": 8618,
	"./saudi-uae-en/translations/index.js": 97663,
	"./tlk-za-en/translations/index.js": 44794,
	"./vc-za-en/translations/index.js": 47608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55153;